import React from 'react'

import { Link } from 'gatsby'

import Button from '@components/Content/Button/Button'
import Image from '@components/Content/WordPress/Image'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'
import Container from '@components/Layout/Container'
import Section from '@components/Layout/Section'

import { HeroType } from '@contracts/acf/hero'
import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './Hero.module.scss'

import BackIcon from '@icons/back.svg'

interface Props extends CustomizableComponent {
	data: HeroType
	heroClass?: string
	smallTitle?: boolean
	isTestimonial?: boolean
	isNews?: boolean
	backLink?: string
	noBottomPadding?: boolean
	breadcrumbs?: React.ReactNode
	heroImageRef?: React.RefObject<HTMLDivElement>
}

const Hero: React.FunctionComponent<Props> = ({
	data,
	heroClass,
	noBottomPadding,
	smallTitle,
	backLink,
	isTestimonial,
	isNews,
	breadcrumbs,
	heroImageRef,
}) => {
	const imageAlt = data.image && data.image.altText ? data.image.altText : data.title
	const heroStyles = [styles.hero]
	const titleStyles = [styles.title]
	const bgStyles = [styles.background]
	const containerStyles = [styles.heroContainer]

	if (heroClass) {
		heroStyles.push(heroClass)
	}

	if (smallTitle) {
		titleStyles.push(styles.smallTitle)
	}

	if (isTestimonial) {
		titleStyles.push(styles.testimonialTitle)
	}

	if (isNews) {
		heroStyles.push(styles.isNews)
		titleStyles.push(styles.newsTitle)
		bgStyles.push(styles.newsBackground)
		containerStyles.push(styles.newsContainer)
	}

	const topPadding = isNews === true
	const hasBottomPadding = noBottomPadding === true

	if (breadcrumbs) {
		heroStyles.push(styles.hasBreadcrumbs)
	}

	return (
		<Section
			className={heroStyles.join(' ')}
			hasContainer={false}
			hasNoTopPadding={topPadding}
			hasNoBottomPadding={hasBottomPadding}
		>
			{breadcrumbs && (
				<Container className={styles.breadcrumbContainer}>
					<div className={styles.breadcrumbs}>{breadcrumbs}</div>
				</Container>
			)}

			<Container className={containerStyles.join(' ')}>
				<div className={styles.main}>
					{(isTestimonial || isNews) && backLink && (
						<Link to={backLink} className={styles.back}>
							<BackIcon /> Back
						</Link>
					)}

					<h1 className={titleStyles.join(' ')} dangerouslySetInnerHTML={{ __html: data.title }} />

					{data.content && <Wysiwyg data={data.content} className={styles.content} />}
					{data.button && <Button data={data.button} className={styles.button} />}
				</div>

				<div className={bgStyles.join(' ')} ref={heroImageRef}>
					<Image image={data.image} altText={imageAlt} className={styles.image} loading={'eager'} />
					<span className={styles.wedgeLeft} />
					<span className={styles.wedgeRight} />
				</div>
			</Container>
		</Section>
	)
}

export default Hero
